/** Service Desk console: Service settings tabs for after-sales (Assets & warranty, Visit templates; SD-S3-10). */
export const serviceAfterSalesSettings = {
  nav: { assets: "Assets & warranty", "visit-templates": "Visit templates" },
  assetsWarranty: {
    window: {
      title: "Warranty window",
      intro: "An asset reads Expiring soon this many days before its warranty ends. The standard is {{default}} days.",
      label: "Days before the end",
      hint: "A whole number from {{min}} to {{max}}.",
      problem: "Enter a whole number of days from {{min}} to {{max}}.",
      save: "Save window",
      saved: "Warranty window saved.",
    },
    categories: {
      title: "Asset categories",
      intro: "The categories an asset can be put in. They come from your industry pack; the asset form and the assets list offer them.",
      none: "No categories yet. Applying an industry pack adds a starting list; until then the category of an asset is free text.",
      count_one: "{{count}} category",
      count_other: "{{count}} categories",
    },
    words: {
      title: "Words for assets and projects",
      intro: "Rename the words the after-sales screens, the portal and e-mails use. Leave one empty to keep the standard word.",
    },
  },
  visitTemplates: {
    intro: "The checklists a visit starts from. They come with your workspace and can't be edited here.",
    forCategory: "For {{category}}",
    anyCategory: "For any asset",
    kind: { corrective: "Corrective", pm: "Preventive maintenance", calibration: "Calibration", installation: "Installation", inspection: "Inspection", training: "Training" },
    inactive: "Not in use",
    checklist: "Checklist of {{name}}",
    emptyTitle: "No visit templates",
    emptyBody: "Visit checklists appear here once they are set up for your workspace.",
  },
} as const;
